var _rect, _line, _rect2, _path, _rect3, _path2, _rect4, _path3, _circle, _path4, _path5, _path6, _path7, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyHabits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 45,
    width: 160,
    height: 175,
    rx: 8,
    stroke: "#fafcfb",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 45,
    x2: 145,
    y2: 220,
    stroke: "#38bdf8",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 68,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 76l3 3 6-6",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 92,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 100l3 3 6-6",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 116,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#fafcfb",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182 74h75M182 98h55M182 122h65M182 146h45M182 170h60",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 105,
    r: 22,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230 83 L230 105 L248 115 A22 22 0 0 0 230 83",
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230 105 L248 115 A22 22 0 0 0 230 127 L230 105",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200 220 Q200 195 190 185 Q200 175 210 185 Q200 195 200 220",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185 195 Q175 185 180 175 M215 195 Q225 185 220 175",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 225,
    rx: 25,
    ry: 6,
    stroke: "#38bdf8",
    strokeOpacity: 0.2,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyHabits);
export default __webpack_public_path__ + "static/media/daily-habits.41742750e8cd6ee507fad450cfb3f66f.svg";
export { ForwardRef as ReactComponent };